import { render, staticRenderFns } from "./brushQuestion.vue?vue&type=template&id=8ce8c31c&scoped=true&"
import script from "./brushQuestion.js?vue&type=script&lang=js&"
export * from "./brushQuestion.js?vue&type=script&lang=js&"
import style0 from "./brushQuestion.css?vue&type=style&index=0&id=8ce8c31c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce8c31c",
  null
  
)

export default component.exports